import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';

import { AuthService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';

/** Pantalla de inicio de sesión. Si el API requiere 2FA redirige a `/2FA`; si no, guarda la sesión y entra al inicio. */
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CardModule,
    FloatLabelModule,
    InputTextModule,
    PasswordModule,
    ToastModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  form: FormGroup;
  loading = false;
  appVersion = environment.appVersion;
  environmentName = environment.environmentName;

  emailControl: FormControl;
  passwordControl: FormControl;

  constructor(
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
  ) {
    this.emailControl = this.fb.control('', [
      Validators.required,
      Validators.email,
    ]);
    this.passwordControl = this.fb.control('', Validators.required);

    this.form = this.fb.group({
      email: this.emailControl,
      password: this.passwordControl,
    });
  }

  onLogin(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    const email = `${this.emailControl.value ?? ''}`.trim();
    const password = `${this.passwordControl.value ?? ''}`;

    this.loading = true;

    this.authService.login(email, password).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.status === 'authenticated') {
          this.authService.setCurrentUser(response.user);
          this.router.navigate(['/']);
          return;
        }

        this.router.navigate(['/2FA']);
      },
      error: () => (this.loading = false),
    });
  }
}
